export default "__VITE_ASSET__CLCc4jf2__"